module.exports = __webpack_public_path__ + "assets/img/shiduan.bc565f58.png";